import React, { useLayoutEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { Divider } from 'antd';

import { selectTranslations } from 'app/pages/App/slice/selectors';
import { Layout } from 'app/pages/NewAccount/layouts';
import { Text, Title } from '../../components/Typo';
import { ACCOUNT_MNG_MENU } from 'app/pages/NewAccount/layouts/AccountManager';
import { ReactComponent as SuccessIcon } from 'app/assets/img/success_icon.svg';

const TicketRefundPendingApprove = () => {
  const translations = useSelector(selectTranslations);
  const { state } = useLocation<any>();
  const orderRefundData = state?.refundTicketOrderData;
  const orderId = orderRefundData?.order?.id;
  const history = useHistory();

  useLayoutEffect(() => {
    if (!orderId) history.push('/page-not-found');
  }, [history, orderId]);

  return (
    <Layout title={null} menuActive={ACCOUNT_MNG_MENU.CHECK_TICKET}>
      <div
        className="d-flex align-items-center justify-content-center flex-column"
        style={{
          padding: '50px 0',
        }}
      >
        <div className="d-flex align-items-center justify-content-center flex-column">
          <SuccessIcon />
          <Title
            style={{
              fontSize: 20,
              marginTop: 24,
              maxWidth: 350,
              textAlign: 'center',
              lineHeight: '32px',
            }}
          >
            {translations?.['b2b.txt.ticketCancellationNotPolicySuccess'] ?? ''}
          </Title>
          <div style={{ marginTop: 32 }}>
            <Title style={{ textTransform: 'initial' }}>
              {translations?.['b2b.txt.ticketCancellationCode'] ?? ''}{' '}
              <span style={{ color: '#E92127' }}>{orderId}</span>
            </Title>
          </div>
          <div style={{ marginTop: 20 }}>
            <Text style={{ textAlign: 'center', maxWidth: '560px' }}>
              {translations?.['b2b.des.refundOrderHasBeenCreated'] ?? ''}
            </Text>
          </div>
          <Divider
            dashed
            style={{
              borderWidth: '2px 0 0',
              borderColor: '#D9D9D9',
              width: 'calc(100% + 18px)',
              marginTop: 15,
              marginBottom: 28,
            }}
          />
          <Text>{translations?.['b2b.txt.ticketRefundContact'] ?? ''}</Text>
          <Title
            style={{ marginTop: 20, fontWeight: 500, textTransform: 'initial' }}
          >
            Hotline{' '}
            <span style={{ color: '#E92127', fontWeight: 700 }}>
              {translations?.['b2b.txt.hotline'] ?? ''}
            </span>
          </Title>
        </div>
      </div>
    </Layout>
  );
};

export default TicketRefundPendingApprove;
